import type React from "react";
import { formatCents } from "../../data/catalog.ts";

export function PricePill({ cents }: { cents: string }) {
  return (
    <span className="inline-flex items-center justify-center h-8 px-3 rounded-full bg-ios-blue/10 text-ios-blue text-[17px] font-semibold tabular-nums leading-none">
      {formatCents(cents)}
    </span>
  );
}

export function AttrPill({ icon, label }: { icon?: React.ReactNode; label: string }) {
  return (
    <span className="inline-flex items-center justify-center gap-1.5 h-8 px-3 rounded-full bg-slate-500/10 text-slate-700 text-[15px] font-medium leading-none">
      {icon}
      <span>{label}</span>
    </span>
  );
}

export function ConditionPill({ condition }: { condition: "new" | "used" }) {
  // iOS green for New, iOS orange for Used — immediately scannable on the floor.
  const isNew = condition === "new";
  const classes = isNew ? "bg-[#34c759]/15 text-[#1a7f3a]" : "bg-[#ff9500]/15 text-[#a35a00]";
  return (
    <span
      className={`inline-flex items-center justify-center h-8 px-3 rounded-full text-[15px] font-semibold uppercase tracking-wide leading-none ${classes}`}
    >
      {isNew ? "New" : "Used"}
    </span>
  );
}

export function FeatureChip({ label }: { label: string }) {
  return (
    <span className="inline-flex items-center h-7 px-2.5 rounded-md bg-ios-blue/10 text-ios-blue text-[14px] font-semibold uppercase tracking-wide leading-none">
      {label}
    </span>
  );
}
